// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './telegram-groups-api';

export const useCreateTelegramGroup: typeof hookExports.useCreateTelegramGroup =
  hookExports.useCreateTelegramGroup;
export const useListTelegramGroups: typeof hookExports.useListTelegramGroups =
  hookExports.useListTelegramGroups;
export const useLazyListTelegramGroups: typeof hookExports.useLazyListTelegramGroups =
  hookExports.useLazyListTelegramGroups;
export const useGetTelegramGroup: typeof hookExports.useGetTelegramGroup =
  hookExports.useGetTelegramGroup;
export const useLazyGetTelegramGroup: typeof hookExports.useLazyGetTelegramGroup =
  hookExports.useLazyGetTelegramGroup;
export const useArchiveTelegramGroup: typeof hookExports.useArchiveTelegramGroup =
  hookExports.useArchiveTelegramGroup;
export const useBulkArchiveTelegramGroups: typeof hookExports.useBulkArchiveTelegramGroups =
  hookExports.useBulkArchiveTelegramGroups;
export const useBulkDeleteTelegramGroups: typeof hookExports.useBulkDeleteTelegramGroups =
  hookExports.useBulkDeleteTelegramGroups;
export const useGetTelegramGroupJob: typeof hookExports.useGetTelegramGroupJob =
  hookExports.useGetTelegramGroupJob;
export const useLazyGetTelegramGroupJob: typeof hookExports.useLazyGetTelegramGroupJob =
  hookExports.useLazyGetTelegramGroupJob;
export const useUpdateTelegramGroup: typeof hookExports.useUpdateTelegramGroup =
  hookExports.useUpdateTelegramGroup;
export const useChangeTelegramGroupBot: typeof hookExports.useChangeTelegramGroupBot =
  hookExports.useChangeTelegramGroupBot;
export const useDeleteTelegramGroup: typeof hookExports.useDeleteTelegramGroup =
  hookExports.useDeleteTelegramGroup;
export const useGetTelegramGroupMembers: typeof hookExports.useGetTelegramGroupMembers =
  hookExports.useGetTelegramGroupMembers;
export const useLazyGetTelegramGroupMembers: typeof hookExports.useLazyGetTelegramGroupMembers =
  hookExports.useLazyGetTelegramGroupMembers;
export const useAddTelegramGroupMembers: typeof hookExports.useAddTelegramGroupMembers =
  hookExports.useAddTelegramGroupMembers;
export const useRemoveTelegramGroupMembers: typeof hookExports.useRemoveTelegramGroupMembers =
  hookExports.useRemoveTelegramGroupMembers;
export const useBulkAddTelegramGroupMembers: typeof hookExports.useBulkAddTelegramGroupMembers =
  hookExports.useBulkAddTelegramGroupMembers;
export const useBulkRemoveTelegramGroupMembers: typeof hookExports.useBulkRemoveTelegramGroupMembers =
  hookExports.useBulkRemoveTelegramGroupMembers;
export const useCreateTelegramGroupInviteLink: typeof hookExports.useCreateTelegramGroupInviteLink =
  hookExports.useCreateTelegramGroupInviteLink;
